import { render, staticRenderFns } from "./attestationNode.vue?vue&type=template&id=a96a3ff4"
import script from "./attestationNode.vue?vue&type=script&lang=js"
export * from "./attestationNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports